import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { GainLossPercents } from "../GainLossPercents";

export type YTDPercentProps = {
  value: number;
  showArrows?: boolean;
};

export const YTDPercents = ({ value, showArrows = false }: YTDPercentProps) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <Typography
        variant="body1"
        color="textSecondary"
        sx={{ fontSize: "12px", marginRight: theme.spacing(1.5) }}
      >
        YTD
      </Typography>
      <GainLossPercents value={value} size="small" showArrows={showArrows} />
    </Box>
  );
};
